import { text, toggle } from '../../themes/settingFields';
import { element, only } from './definition';
import { look, typeface } from './styleTokens';

// The bar that rises from the bottom of a product page once its buy box has scrolled out of sight, holding
// the product, its option, the quantity and the button. It sits inside a product block, which says which
// product it buys; it is offered only on the pages that sell one.

/** The sticky add-to-cart bar. */
export const stickyBuyElement = element('sticky-buy', {
  label: 'Sticky add to cart',
  description: 'A bar that rises from the bottom once the buy button has scrolled away. Place it inside the product block.',
  category: 'Other',
  icon: 'shopping-bag',
  binds: only(['product', 'product-cod']),
  props: [text('label', 'Button text'), { ...toggle('showQuantity', 'Quantity'), help: 'Phones show the option and the button only.' }],
  defaults: { props: { label: 'Add to cart', showQuantity: true }, styles: look({ fontFamily: typeface('body') }) }
});
